const STORAGE_KEY = 'salonCityCache';

/** Cache in memoria: evita JSON.parse(localStorage) per ogni salone in lista. */
let memoryCache = null;

const readCache = () => {
  if (memoryCache) return memoryCache;
  try {
    memoryCache = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
  } catch (_) {
    memoryCache = {};
  }
  return memoryCache;
};

const writeCache = (cache) => {
  memoryCache = cache;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
  } catch (_) {
    // ignore quota / private mode
  }
};

export const getCachedSalonCity = (salonId) => {
  if (salonId == null || salonId === '') return '';
  const value = readCache()[String(salonId)];
  return typeof value === 'string' && value.trim() ? value.trim() : '';
};

/** Persiste la città quando l'API la manda, così un tokenLogin con citta:null non la cancella. */
export const rememberSalonCity = (salonId, city) => {
  if (salonId == null || salonId === '') return;
  const trimmed = typeof city === 'string' ? city.trim() : '';
  if (!trimmed) return;
  const cache = { ...readCache() };
  if (cache[String(salonId)] === trimmed) return;
  cache[String(salonId)] = trimmed;
  writeCache(cache);
};

export const rememberSalonCities = (salons = []) => {
  if (!Array.isArray(salons)) return;
  let changed = false;
  const cache = { ...readCache() };
  salons.forEach((salon) => {
    if (!salon) return;
    const id = salon.idsalone ?? salon.id;
    if (id == null || id === '') return;
    const city =
      (typeof salon.citta === 'string' && salon.citta.trim()) ||
      (typeof salon.comune === 'string' && salon.comune.trim()) ||
      (typeof salon.city === 'string' && salon.city.trim()) ||
      (typeof salon.localita === 'string' && salon.localita.trim()) ||
      (typeof salon.citta_salone === 'string' && salon.citta_salone.trim()) ||
      '';
    if (!city) return;
    if (cache[String(id)] === city) return;
    cache[String(id)] = city;
    changed = true;
  });
  if (changed) writeCache(cache);
};
